export const ROUTES = {
  SEARCH: "/search",
  EXPLORE: "/explore",
  FAVORITES: "/favorites",
  LOGIN: "/login",
  CAMPGROUND: "/campground",
  RANGER_STATION: "/ranger-station",
};
